import ReactGA from "react-ga4";

export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (measurementId) {
    try {
      ReactGA.initialize(measurementId);
    } catch (e) {
      console.warn("GA Initialization failed:", e);
    }
  } else {
    console.warn("GA Measurement ID not found");
  }
  
  // Set up global error handler for automatic exception tracking
  const originalConsoleError = console.error;
  console.error = (...args) => {
    // Log to Google Analytics
    logException(args.join(' '), false);
    // Call original console.error
    originalConsoleError.apply(console, args);
  };
  
  // Capture unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    logException(`Unhandled Promise Rejection: ${event.reason}`, true);
  });
  
  // Capture uncaught exceptions
  window.addEventListener('error', (event) => {
    logException(`${event.message} at ${event.filename}:${event.lineno}:${event.colno}`, true);
    // Don't prevent default to allow normal error handling
  });
  
  // Return cleanup function for use in useEffect
  return () => {
    console.error = originalConsoleError;
    window.removeEventListener('unhandledrejection', null);
    window.removeEventListener('error', null);
  };
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};

export const logEvent = (category, action, label) => {
  ReactGA.event({ category, action, label });
};

export const logException = (description, fatal) => {
  // ReactGA4 doesn't support exception method directly in the same way as GA3
  // Sending as a custom event instead
  ReactGA.event({
    category: "Exception",
    action: fatal ? "Fatal Error" : "Error",
    label: String(description),
  });
};;
